import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-radiologie',
  templateUrl: './template-radiologie.component.html',
  styleUrls: ['./template-radiologie.component.scss']
})
export class TemplateRadiologieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
